import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { action } from 'satcheljs/lib/legacy';
import updateUserConfiguration from 'owa-session-store/lib/services/updateUserConfiguration';
import userConfigurationDictionaryEntry from 'owa-service/lib/factory/userConfigurationDictionaryEntry';
import userConfigurationDictionaryObject from 'owa-service/lib/factory/userConfigurationDictionaryObject';
import { setIsFocusedInboxCapableService } from 'owa-mail-focused-inbox-config/lib/services/setIsFocusedCapableService';
// Initialize focused inbox config
export default action('initializeFocusedInboxConfig')(function initializeFocusedInboxConfig() {
    if (!getUserConfiguration().UserOptions.IsFocusedInboxFeatureSupported) {
        return;
    }
    var userOptions = getUserConfiguration().UserOptions;
    var isFocusedInboxEnabledDefined = userOptions.IsFocusedInboxEnabled != null;
    var userTimeStamp = userOptions.IsFocusedInboxOnLastUpdateTime != null
        ? new Date(userOptions.IsFocusedInboxOnLastUpdateTime).getTime()
        : null;
    var adminTimeStamp = userOptions.IsFocusedInboxOnLastUpdateTime != null
        ? new Date(userOptions.IsFocusedInboxOnAdminLastUpdateTime).getTime()
        : null;
    // Initialize IsFocusedInboxEnabled on first logon (when IsFocusedInboxEnabled is null) or if admin overrides the Focused Inbox On setting
    if (!isFocusedInboxEnabledDefined ||
        (userTimeStamp != null && adminTimeStamp != null && adminTimeStamp > userTimeStamp)) {
        getUserConfiguration().UserOptions.IsFocusedInboxEnabled =
            userOptions.FocusedInboxServerOverride;
        getUserConfiguration().UserOptions.IsFocusedInboxOnLastUpdateTime =
            userOptions.IsFocusedInboxOnAdminLastUpdateTime;
        updateUserConfiguration('OWA.UserOptions', [
            userConfigurationDictionaryEntry({
                DictionaryKey: userConfigurationDictionaryObject({
                    Type: 'String',
                    Value: ['IsFocusedInboxEnabled'],
                }),
                DictionaryValue: userConfigurationDictionaryObject({
                    Type: 'Boolean',
                    Value: [String(userOptions.FocusedInboxServerOverride)],
                }),
            }),
            userConfigurationDictionaryEntry({
                DictionaryKey: userConfigurationDictionaryObject({
                    Type: 'String',
                    Value: ['IsFocusedInboxOnLastUpdateTime'],
                }),
                DictionaryValue: userConfigurationDictionaryObject({
                    Type: 'String',
                    Value: [userOptions.IsFocusedInboxOnAdminLastUpdateTime],
                }),
            }),
        ]);
        // Make a request to set IsFocusedInboxCapable if IsFocusedInboxEnabled is set to true
        if (getUserConfiguration().UserOptions.IsFocusedInboxEnabled) {
            setIsFocusedInboxCapableService();
        }
    }
});
//# sourceMappingURL=initializeFocusedInboxConfig.js.map